export const CREATE_FANCLUB_START = 'OPEN_FC_REGISTER/CREATE_FANCLUB_START' as const;
export const CREATE_FANCLUB_SUCCEED = 'OPEN_FC_REGISTER/CREATE_FANCLUB_SUCCEED' as const;
export const CREATE_FANCLUB_FAIL = 'OPEN_FC_REGISTER/CREATE_FANCLUB_FAIL' as const;

export const CLEANUP = 'OPEN_FC_REGISTER/CLEANUP' as const;
